import { Box, useColorModeValue } from '@chakra-ui/react'

import NavigationBar from '../Components/NavigationBar'
import Footer from '../Components/Footer'
import { ContactInformation } from '../Features/Contact'
import { Hero } from '../Components/PolicyWrapper'

import GlobalAlertDialog from '../Components/Elements/GlobalAlertDialog'

export const meta = () => {
  return [
    {
      title: 'daddysteach - Contact Us'
    },
    {
      name: 'description',
      content: 'Get in touch with us on our contact page. Our team is here to assist you with any questions or concerns you may have. Reach out now to connect with us.'
    }
  ]
}

const Contact = () => {
  const backgroundColor = useColorModeValue('gray.50', 'gray.900')

  return (
    <Box bgColor={backgroundColor}>
      <NavigationBar />
      <GlobalAlertDialog />
      <Hero label={'Contact Us'} />
      {/* <ContactForm /> */}
      <ContactInformation />
      <Footer />
    </Box>
  )
}

export default Contact